import { required, minLength, maxLength } from "react-admin";

export const validateName = [required(), minLength(5), maxLength(40)];
